import React, {Component} from "react"
import Report from '../../Report/Report'
import {Link} from 'react-router-dom'
import './PolishingModuleStart.sass'
import Error from '../../Error/Error'

class PolishingModuleStart extends Component {

  render() {
    const input1 = JSON.parse(localStorage.getItem('InputParams1'))

    if (!input1) {
      return (

        <Error
          error='Введите и сохраните параметры заготовки'
          title='Шлифовальный круг для предварительного шлифования'
        />

      )
    }


    let polished = '24А 25 С2 К5'

    let value

    if (input1.polMethod) {

      polished = input1.diskParams

    }

    value = polished.split(' ')

    return (
      <React.Fragment>

        <main className='params'>
          <h1 className='params__title'>Шлифовальный круг для предварительного шлифования</h1>

          <div className="params-content">

            <div className="params-content-box">
              <h2 className='polishing__title'>Характеристика круга</h2>
              <div className="polishing__disk">{polished}</div>
            </div>

            <div className="params-content-box">
              <div className="polishing-box">
                <div className="polishing-box__item">
                  <h2 className='polishing-box__subtitle'>
                    Припуск на обработку
                  </h2>
                  <div className="polishing-box__border">0,32 мм</div>
                </div>
                <div className="polishing-box__item">
                  <h2 className='polishing-box__subtitle'>
                    Шероховатость после обработки
                  </h2>
                  <div className="polishing-box__border">Ra0,63</div>
                </div>
              </div>
            </div>

            <div className="params-content-box">
              <div className="polishing-box">
                <div className="polishing-box__item">
                  <div className="polishing-box-wrapper">
                    <h2 className='polishing-box__subtitle'>
                      Абразивный материал
                    </h2>
                    <div className="polishing-box__border inline-block">
                      {value[0]}
                    </div>
                  </div>
                  <div className="polishing-box-wrapper">
                    <h2 className='polishing-box__subtitle'>
                      Зернистость
                    </h2>
                    <div className="polishing-box__border inline-block">
                      {value[1]}
                    </div>
                  </div>
                  <div className="polishing-box-wrapper">
                    <h2 className='polishing-box__subtitle'>
                      Твердость
                    </h2>
                    <div className="polishing-box__border inline-block">
                      {value[2]}
                    </div>
                  </div>
                </div>
                <div className="polishing-box__item">
                  <div className="polishing-box-wrapper">
                    <h2 className='polishing-box__subtitle'>
                      Связка
                    </h2>
                    <div className="polishing-box__border inline-block">
                      {value[3].split('')[0]
                      }
                    </div>
                  </div>
                  <div className="polishing-box-wrapper">
                    <h2 className='polishing-box__subtitle'>
                      Структура
                    </h2>
                    <div className="polishing-box__border inline-block">
                      {value[3].split('')[1]}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="polishing-link">
              <Link to='/modules/polishing/finish' className="polishing-link__next">
              </Link>
            </div>


          </div>

        </main>

        <Report/>
      </React.Fragment>
    )
  }
}

export default PolishingModuleStart